/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormGroup, FormControl, FormControlLabel, FormHelperText, InputLabel } from '@material-ui/core/';
import useStyles from './styles';

const CustomCheckbox = ({
  input,
  name: explicitName,
  fullWidth,
  customStyles,
  onItemChange,
  id,
  label,
  meta,
  ...rest
}) => {
  const classes = useStyles();
  const fieldName = (input && input.name) || explicitName || '';
  const serverError = meta && !meta.dirtySinceLastSubmit ? meta.submitError : null;
  const isError = Boolean((meta && meta.error && meta.touched) || serverError);

  return (
    <FormControl className={customStyles} component="fieldset" fullWidth={fullWidth} error={isError}>
      <InputLabel className={classes.label} shrink htmlFor={id}>
        {label}
      </InputLabel>
      <FormGroup className={classes.group} aria-label={fieldName} name={fieldName}>
        {rest.items.map(item => (
          <FormControlLabel
            key={item.id}
            value={item.id}
            checked={item.deletedAt === null}
            control={
              <Checkbox
                className={classes.checkbox}
                checked={item.deletedAt === null}
                onChange={e => onItemChange(e)}
                value={item.id}
                {...rest}
              />
            }
            label={item.name}
          />
        ))}
      </FormGroup>
      {isError && (
        <FormHelperText id="outlined-weight-helper-text" error>
          {(meta && meta.error) || serverError}
        </FormHelperText>
      )}
    </FormControl>
  );
};

CustomCheckbox.defaultProps = {
  input: undefined,
  meta: undefined,
  name: undefined,
  fullWidth: false,
  customStyles: undefined,
};

CustomCheckbox.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
  }),
  name: PropTypes.string,
  onItemChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape(),
  id: PropTypes.string.isRequired,
  customStyles: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default CustomCheckbox;
